import { connect } from 'react-redux';

import { withRouter } from 'src/router/utils';
import { getIsSiteMessageActive } from 'src/selectors/global-selectors';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getCurrentUserIsAnonymous } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import Header from '../components/header';

const mapStateToProps = (state: BucketState) => {
  const { atRef, hash, ref } = state.repository.source.section;

  const repository = getCurrentRepository(state);

  return {
    currentRef: atRef || ref,
    hash,
    isBannerOpen: getIsSiteMessageActive(state),
    repository,
    repositoryAccessLevel: state.repository.details.accessLevel,
    userIsAnonymous: getCurrentUserIsAnonymous(state),
    forkPolicy: repository?.fork_policy,
  };
};

export default withRouter(connect(mapStateToProps)(Header));
